import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'covance-expansion-panel',
    template: require('./covance-expansion-panel.component.html'),
    styles: [require('./covance-expansion-panel.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CovanceExpansionPanelComponent {
    @Input()
    public isToggled: boolean;

    public toggle(): void {
        this.isToggled = !this.isToggled;
    }
}
